import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../styles/theme";
import ApartmentIcon from "@mui/icons-material/Apartment";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AnimationIcon from "@mui/icons-material/Animation";
import AdUnitsIcon from "@mui/icons-material/AdUnits";
import PaymentIcon from "@mui/icons-material/Payment";
const StatBox = ({ title, subtitle, icon, progress, increase, prtitele }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box width="100%" m="0 30px">
      <Box display="flex" justifyContent="space-between">
        <Box>
          {icon}
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ color: colors.grey[100] }}
            className="title-client"
          >
            {title}
          </Typography>
        </Box>
        <Box>
          {prtitele === "users" ? (
            <PeopleAltIcon className="icon-build" />
          ) : prtitele == "build" ? (
            <ApartmentIcon className="icon-build" />
          ) : prtitele == "unit" ? (
            <AdUnitsIcon />
          ) : prtitele == "cash" ? (
            <AnimationIcon />
          ) : prtitele == "bill" ? (
            <PaymentIcon />
          ) : (
            <></>
          )}
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" mt="2px">
        <Typography variant="h5" sx={{ color: colors.greenAccent[500] }}>
            { subtitle }
        </Typography>
        <Typography
          variant="h5"
          fontStyle="italic"
          sx={{ color: colors.greenAccent[600] }}
        >
          {increase}
        </Typography>
      </Box>
    </Box>
  );
};

export default StatBox;
